export const emptyAccountMedication = {
  id: "",
  med_id: null,
  units: "",
  med: {
    category: "",
  },
}
